import { service } from "../utils/request";

// 车队设置
export function Set(data) {
  return service({
    url: "teamcard/agent.Setting/saveConfig",
    method: "post",
    data: data
  });
}
// 获取车队设置
export function getSet(data) {
  return service({
    url: "/teamcard/agent.Setting/index",
    method: "post",
    data: data
  });
}
// 审核
export function audit(data) {
  return service({
    url: "/teamcard/agent.Team_Card_apply/edit",
    method: "post",
    data: data
  });
}

// 车队列表
export function List(data) {
  return service({
    url: "/teamcard/agent.Team_Card_apply/index",
    method: "post",
    data: data
  });
}
// 删除车队列表
export function ListDel(data) {
  return service({
    url: "/teamcard/agent.Team_Card_apply/del",
    method: "post",
    data: data
  });
}
// 车队卡
export function cardList(data) {
  return service({
    url: "/teamcard/agent.Team_Card_Type/index",
    method: "post",
    data: data
  });
}
// 添加车队卡
export function addcard(data) {
  return service({
    url: "/teamcard/agent.Team_Card_Type/add",
    method: "post",
    data: data
  });
}
// 车队卡详情
export function detailCard(data) {
  return service({
    url: "/teamcard/agent.Team_Card_Type/detail",
    method: "post",
    data: data
  });
}
// 添加车队卡
export function erditCard(data) {
  return service({
    url: "/teamcard/agent.Team_Card_Type/edit",
    method: "post",
    data: data
  });
}
// 删除车队卡
export function delCard(data) {
  return service({
    url: "/teamcard/agent.Team_Card_Type/del",
    method: "post",
    data: data
  });
}
// 分组列表
export function groupList(data) {
  return service({
    url: "/teamcard/agent.Team_group/index",
    method: "post",
    data: data
  });
}
// 添加分组
export function groupAdd(data) {
  return service({
    url: "/teamcard/agent.Team_group/add",
    method: "post",
    data: data
  });
}
// 编辑分组
export function groupEdit(data) {
  return service({
    url: "/teamcard/agent.Team_group/edit",
    method: "post",
    data: data
  });
}
// 分组详情
export function groupDetail(data) {
  return service({
    url: "/teamcard/agent.Team_group/detail",
    method: "post",
    data: data
  });
}
// 删除分组
export function groupDel(data) {
  return service({
    url: "/teamcard/agent.Team_group/del",
    method: "post",
    data: data
  });
}
// 移动分组信息
export function groupMove(data) {
  return service({
    url: "/teamcard/agent.Team_Card_Apply/move_group",
    method: "post",
    data: data
  });
}
// 车队卡余额记录
export function team_balance_logs(data) {
  return service({
    url: "/teamcard/agent.team_card/team_balance_logs",
    method: "post",
    data: data
  });
}
// 车队卡余额变更统计
export function team_balance_count(data) {
  return service({
    url: "/teamcard/agent.team_card/team_balance_count",
    method: "post",
    data: data
  });
}
